import { useEffect, useState } from "react";
import { workdayConfigRepo } from "@/services/workday_config.repository";
import { DEFAULT_WORKDAY_CONFIG, type WorkdayConfig } from "@/domain/workday";

/** 업무일/휴일 조직 정책(system_settings/workday_config) 구독. */
export function useWorkdayConfig() {
  const [config, setConfig] = useState<WorkdayConfig>(DEFAULT_WORKDAY_CONFIG);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const unsub = workdayConfigRepo.watch(
      (c) => {
        setConfig(c);
        setLoaded(true);
      },
      () => setLoaded(true),
    );
    return unsub;
  }, []);

  return { config, loaded };
}
